import { render, staticRenderFns } from "./MerchantChannelType.vue?vue&type=template&id=bb298ada&"
import script from "./MerchantChannelType.vue?vue&type=script&lang=ts&"
export * from "./MerchantChannelType.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantChannelType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantChannelType.vue"
export default component.exports